import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { getDataFinance as getDataFinanceApi, } from '../../helpers/data_finance/backend_helper';

export const getDataFinance = createAsyncThunk('field/getDataFinance', async ({ requestData, dataType }) => {
	try {
		const response = await getDataFinanceApi(requestData);
		return { data: response['data'], dataType };
	} catch (error) {
		throw new Error(error);
	}
}
);
